"use strict";
/* AUTOMATICALLY GENERATED BY `yarn codegen`. DO NOT EDIT. */
/* eslint-disable */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSdk = exports.GetRunnersByOwnerDocument = exports.GetRunnersDocument = exports.GetRunnerByIdDocument = exports.GetBioForRunnerDocument = exports.GetAllTraitsDocument = exports.TraitFragmentDoc = exports.RunnerFragmentDoc = exports.UserRole = exports.TraitType = exports.RichTextStyle = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
var RichTextStyle;
(function (RichTextStyle) {
    RichTextStyle["Bold"] = "BOLD";
    RichTextStyle["Italic"] = "ITALIC";
    RichTextStyle["Monospace"] = "MONOSPACE";
    RichTextStyle["Strikethrough"] = "STRIKETHROUGH";
    RichTextStyle["Underline"] = "UNDERLINE";
})(RichTextStyle = exports.RichTextStyle || (exports.RichTextStyle = {}));
var TraitType;
(function (TraitType) {
    TraitType["Background"] = "Background";
    TraitType["EarAccessory"] = "EarAccessory";
    TraitType["EyeAccessory"] = "EyeAccessory";
    TraitType["Eyes"] = "Eyes";
    TraitType["Face"] = "Face";
    TraitType["FaceAccessory"] = "FaceAccessory";
    TraitType["HeadAbove"] = "HeadAbove";
    TraitType["HeadBelow"] = "HeadBelow";
    TraitType["Mask"] = "Mask";
    TraitType["Mouth"] = "Mouth";
    TraitType["MouthAccessory"] = "MouthAccessory";
    TraitType["Nose"] = "Nose";
    TraitType["Race"] = "Race";
})(TraitType = exports.TraitType || (exports.TraitType = {}));
var UserRole;
(function (UserRole) {
    UserRole["SuperAdmin"] = "SuperAdmin";
    UserRole["User"] = "User";
})(UserRole = exports.UserRole || (exports.UserRole = {}));
exports.RunnerFragmentDoc = (0, graphql_tag_1.default) `
    fragment runner on Token {
  __typename
  id
  rawMetadata
  ownerAddress
  dnaString
  traitIds
  updatedAt
  createdAt
}
    `;
exports.TraitFragmentDoc = (0, graphql_tag_1.default) `
    fragment trait on Trait {
  __typename
  id
  name
  displayName
  type
  traitIndex
  tokenCount
}
    `;
exports.GetAllTraitsDocument = (0, graphql_tag_1.default) `
    query getAllTraits {
  traits {
    records {
      ...trait
    }
    count
  }
}
    ${exports.TraitFragmentDoc}`;
exports.GetBioForRunnerDocument = (0, graphql_tag_1.default) `
    query getBioForRunner($runnerId: Int!) {
  bioForRunner(runnerId: $runnerId) {
    textContent {
      text
      inlineStyleRanges {
        length
        style
        offset
      }
    }
  }
}
    `;
exports.GetRunnerByIdDocument = (0, graphql_tag_1.default) `
    query getRunnerById($id: ID!) {
  token(id: $id) {
    ...runner
  }
}
    ${exports.RunnerFragmentDoc}`;
exports.GetRunnersDocument = (0, graphql_tag_1.default) `
    query getRunners($options: TokenQueryOptions) {
  tokens(options: $options) {
    count
    records {
      ...runner
    }
  }
}
    ${exports.RunnerFragmentDoc}`;
exports.GetRunnersByOwnerDocument = (0, graphql_tag_1.default) `
    query getRunnersByOwner($owner: String!) {
  tokens(options: {filters: {ownedBy: $owner}}) {
    count
    records {
      ...runner
    }
  }
}
    ${exports.RunnerFragmentDoc}`;
const defaultWrapper = (action, _operationName) => action();
function getSdk(client, withWrapper = defaultWrapper) {
    return {
        getAllTraits(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetAllTraitsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'getAllTraits');
        },
        getBioForRunner(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetBioForRunnerDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'getBioForRunner');
        },
        getRunnerById(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetRunnerByIdDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'getRunnerById');
        },
        getRunners(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetRunnersDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'getRunners');
        },
        getRunnersByOwner(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetRunnersByOwnerDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'getRunnersByOwner');
        }
    };
}
exports.getSdk = getSdk;
//# sourceMappingURL=generated.js.map